document.addEventListener("DOMContentLoaded", () => {
  var footerTitle = $(".footer .footer-block__heading");
  if (window.innerWidth < 768) {
    if (footerTitle.length) {
      footerTitle.off("click.slideToggle").on("click.slideToggle", function () {
        $(this).next().slideToggle();
        $(this).toggleClass("open");
      });
    }
  } else {
    footerTitle.next().css({display: ""});
  }
});
